import { useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import get from "lodash.get";

import { CancelButton, Input, SaveButton } from "components";
import { REQUEST_STATUS, useRequest } from "hooks";
import { FORM_NAMES } from "../constants";

const AddInstructionVideo = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { formState, handleSubmit, control, setValue } = useForm();
  const [client, , status] = useRequest();
  const [getByIdClient, getByIdData] = useRequest();
  const hasFetchedForId = useRef<string | null>(null);
  const hasSetForm = useRef(false);

  const isEdit = !!id;

  // GetById — faqat id o‘zgarganda bir marta (getByIdClient dependency loop sabab qo‘shilmaydi)
  useEffect(() => {
    if (!id) return;
    if (hasFetchedForId.current === id) return;
    hasFetchedForId.current = id;
    hasSetForm.current = false;
    getByIdClient.get(`instruction-video/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Formani faqat bir marta to‘ldirish (loop oldini olish)
  useEffect(() => {
    if (!id || !getByIdData?.data) return;
    const data = get(getByIdData, "data", {});
    if (!data._id || hasSetForm.current) return;
    hasSetForm.current = true;
    setValue(FORM_NAMES.name, data.name ?? "");
    setValue(FORM_NAMES.url, data.url ?? "");
  }, [id, getByIdData, setValue]);

  const submit = async (data: { name: string; url: string }) => {
    if (isEdit) {
      await client.put("instruction-video", {
        _id: id,
        name: data.name,
        url: data.url,
      });
    } else {
      await client.post("instruction-video", {
        name: data.name,
        url: data.url,
      });
    }
  };

  useEffect(() => {
    if (status === REQUEST_STATUS.success) {
      navigate("/instruction-video");
    }
  }, [status, navigate]);

  return (
    <div className="container-scroll">
      <form className="customContainer" onSubmit={handleSubmit(submit as any)}>
        <Grid container spacing={4}>
          <Grid item md={6}>
            <Input
              control={control}
              name={FORM_NAMES.name}
              FORM_NAMES={FORM_NAMES}
              label={t("COMMON.VIDEO_NAME")}
              rules={{ required: { value: true, message: t("COMMON.REQUIRED") } }}
              errors={formState.errors}
              placeholder="1-video"
            />
          </Grid>
          <Grid item md={6}>
            <Input
              control={control}
              name={FORM_NAMES.url}
              FORM_NAMES={FORM_NAMES}
              label={t("COMMON.VIDEO_URL")}
              rules={{ required: { value: true, message: t("COMMON.REQUIRED") } }}
              errors={formState.errors}
              placeholder="https://www.youtube.com/watch?v=..."
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          className="mt-3"
          alignItems="center"
          justifyContent="end"
        >
          <CancelButton type="button" onClick={() => navigate(-1)} />
          <SaveButton
            type="submit"
            className="ms-3"
            disabled={status === REQUEST_STATUS.loading}
            status={status}
          />
        </Grid>
      </form>
    </div>
  );
};

export default AddInstructionVideo;
